import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

import styled from 'styled-components';

// IMPORT FUNCTIONS
import getUrl from  "../../utils/functions/getUrl";

import LogoutIcon from '@mui/icons-material/Logout';
import CreateNewFolderIcon from '@mui/icons-material/CreateNewFolder';
import DeleteIcon from '@mui/icons-material/Delete';
import PermMediaIcon from '@mui/icons-material/PermMedia';
import FolderDeleteIcon from '@mui/icons-material/FolderDelete';
import ArtTrack from '@mui/icons-material/ArtTrack';


const Header = ( { logged, setToggleModal, showDeletedImages, setShowDeletedImages, setInAlbumOnly, inAlbumOnly }) => {

  const BASE_URL = getUrl();
  console.log(`BASE_URL: ${BASE_URL}`);


  // const [userData, setUserData] = useState(sessionStorage.userData ? JSON.parse(sessionStorage.userData) : null);

  useEffect(()=>{
    console.log(`logged: ${logged}`);
  },[logged])

  const styles = inAlbumOnly ? 
    {fontSize: "2.5rem", color: "white"} 
    :
    {fontSize: "2.5rem", color: "gray"}
    


  return (
    <Wrapper id="header--wrapper">
      <Container id="header--container">
        <LogoWrapper id="header--logo-wrapper"><Link to={BASE_URL +"/"}>PictureViewer</Link></LogoWrapper>
        <Linker id="header--linker">
          <LinkItem className="header--linker-item">
            {logged && (
              !inAlbumOnly ?
                <span onClick={()=>setInAlbumOnly(!inAlbumOnly)} 
                  title='in album only'>
                <ArtTrack style={styles} /></span>
              : 
                <span onClick={()=>setInAlbumOnly(!inAlbumOnly)} 
                  title='all pictures'>
                <ArtTrack style={styles} /></span>
              )
            }
          </LinkItem>
          <LinkItem>
            {logged && <span onClick={()=>setToggleModal(true)} title='create new album'><CreateNewFolderIcon /></span>}
          </LinkItem>
          <LinkItem>
            {logged && (
              !showDeletedImages ?
                <span onClick={()=>setShowDeletedImages(true)} title='deleted images folder'><FolderDeleteIcon /></span>
              :
                <span onClick={()=>setShowDeletedImages(false)} title='images folder'><PermMediaIcon /></span>
              )
            }
          </LinkItem>
          <LinkItem>
            {logged && <Link to={BASE_URL +"/logout"} 
              title='logout'><LogoutIcon /> </Link>
            }
          </LinkItem>
        </Linker>
      </Container>
    </Wrapper>
  )
}

export default Header;

const Wrapper = styled.div `
  width: 100%;
  height: 10vh;
  overflow: hidden;
  color: #d1d1d1;
  background-color: rgba(0,0,0,0.4);
  font-size: 2rem;
  padding: 10px 30px;
  border-bottom: 1px solid #666;

  display: flex;
  align-items: center;
  justify-content: center;
  align-items: baseline;

  @media screen AND (max-height: 575px) {
    height: 15vh;

  }
`;

const Container = styled.div `
  width: 1400px;
  margin: 0 auto;

  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const LogoWrapper = styled.div `
  font-size: 3rem;
  color: orange;

  @media screen AND (max-height: 899px) {
    font-size: 2rem;
  }
  @media screen AND (max-height: 575px) {
    font-size: 1.6rem;
  }
    
  
`;

const Linker = styled.div `
  display: flex;
  align-items: center;

  /* margin-right: 20px;; */
`;

const LinkItem = styled.div `
  margin-right: 2rem;
  font-size: 1rem;

  span {
    /* margin-right: 20px; */

    @media screen AND (max-width: 415px) {
      margin-right: .5rem;
    }
  }

  @media screen AND (max-width: 902px) {
    margin-right: 1rem;
  }
  @media screen AND (max-width: 600px) {
    margin-right: 0rem;
  }
  
`;







